<h3>出荷先登録（
  <span *ngIf="willAdd else exist">新規追加</span>
  <ng-template #exist><span>既存のマスタから選択</span></ng-template>
  ）
</h3>
<mat-slide-toggle style="margin-bottom: 20px" [(ngModel)]="willAdd">
  新規作成</mat-slide-toggle>
<ng-container *ngIf="willAdd">
  <form #form="ngForm">
    <div fxLayout="column" fxLayoutGap="10px">
      <mat-form-field style="width: 200px" >
        <mat-label>
          出荷先名
        </mat-label>
        <input matInput required placeholder="出荷先名"
               name="name" [(ngModel)]="newShukkaSaki.name">
      </mat-form-field>
      <mat-form-field style="width: 200px" >
        <mat-label>
          出荷先名(略称)
        </mat-label>
        <input matInput required placeholder="出荷先名(略称)"
               name="shukkaSakiRyakushou" [(ngModel)]="newShukkaSaki.shukkaSakiRyakushou">
      </mat-form-field>
      <div fxLayout="row">
        <button mat-button color="primary" [disabled]="form.invalid"
                (click)="register();">登録
        </button>
        <span class="fill-remaining-space"></span>
      </div>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="!willAdd">
  <ng-select style="width: 200px;"
             [items]="masterService.shukkaSakiMaster | isDeletedFilter:false"
             bindLabel="name"
             placeholder="出荷先"
             [closeOnSelect]="true"
             [multiple]="false"
             [(ngModel)]="selectedShukkaSaki"
             appendTo="body"
             name="selectedShukkaSaki"></ng-select>
  <button mat-button color="primary" [disabled]="!selectedShukkaSaki"
          (click)="selectExistingValue();">変更
  </button>
</ng-container>
